import { render, staticRenderFns } from "./modalTareas.vue?vue&type=template&id=2cad7df4&"
import script from "./modalTareas.vue?vue&type=script&lang=js&"
export * from "./modalTareas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports